import styled from 'styled-components';

export const StyledSignInForm = styled.div`
  .sif-wrapper {
    &-top {
      .pkg-select {
        margin-bottom: 25px;
      }

      &-box {
        width: 100%;
        margin-bottom: 16px;
        height: 40px;

        > input {
          width: 100%;
        }

        &.flex {
          display: flex;
          align-items: center;
          gap: 6px;

          .nation-select {
            width: 142px;
            height: 40px;

            .MuiInputBase-root {
              padding: 0 !important;
              /* padding-left: 13px !important; */
              padding-right: 0px !important;

              .MuiInputBase-input {
                padding-left: 0 !important;

                &::placeholder {
                  padding-left: 10px;
                }
              }
            }
          }

          > div {
            margin-bottom: 0;

            &:last-child {
              width: calc(100% - 142px);
            }
          }
        }

        &:last-child {
          margin-bottom: 0;
        }
      }
    }

    &-middle {
      margin-top: 15px;

      &-top {
        display: flex;
        align-items: center;
        justify-content: space-between;
        color: var(--color-white);
        margin-bottom: 31px;

        &-left {
          > div {
            color: var(--color-white) !important;

            > p {
              color: var(--color-white);
            }
          }
        }

        &-right {
          cursor: pointer;
          color: var(--color-white);
        }
      }

      &-body {
        display: flex;
        justify-content: center;
        gap: 14px;

        > button {
          text-transform: capitalize;

          &:first-of-type {
            background: var(--color-secondary-blue) !important;
          }
        }
      }
    }
  }

  input[type='number']::-webkit-outer-spin-button,
  input[type='number']::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  input[type='number'] {
    -moz-appearance: textfield;
  }
`;
